module.exports = __webpack_public_path__ + "img/gjort-til-grin-2.d01b916e.png";